export const VoucherSource = {
  Sale: 'sale',
  Order: 'order',
} as const;

export type VoucherSource = (typeof VoucherSource)[keyof typeof VoucherSource] | null;

interface Params {
  sale?: { id: string };
  order?: { id: string };
}

export function resolveVoucherSource({ sale, order }: Params): VoucherSource {
  if (sale) return VoucherSource.Sale;
  if (order) return VoucherSource.Order;

  return null;
}
